import React from 'react';
import I18n from 'i18n-js';
import { parseAmountCents, CentsCurrencyMoneyObject } from '@reverbdotcom/commons/src/money';
import FilterChip from '@reverbdotcom/commons/src/components/filter_chip';
import { core_apimessages_Money } from '@reverbdotcom/commons/src/rql';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';

export const COMPONENT_NAME = 'QuickPriceEditPercentOffFilterChips';

export const PERCENTS_OFF = [
  5,
  10,
  15,
];
interface IExternalProps {
  listingId: string | number;
  originalPrice: core_apimessages_Money;
  currentPrice: core_apimessages_Money;
  updatePrice: React.Dispatch<any>;
}

export function calculateDiscountedPrice(price: CentsCurrencyMoneyObject, percent_off: number) {
  const percentage = (100 - percent_off) / 100.00;
  const discountedPriceCents = Math.round(percentage * price.amountCents);
  return parseAmountCents(discountedPriceCents, price.currency);
}

export default function QuickPriceEditPercentOffFilterChips({
  listingId,
  originalPrice,
  currentPrice,
  updatePrice,
}: IExternalProps) {

  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: COMPONENT_NAME,
    listingId,
  }, true);

  return (
    <div className="quick-price-edit-percent-off-filter-chips">
      <span>
        {I18n.t('discovery.listingsManagement.quickPriceEdit.modal.percentOffFilterChips.label')}
      </span>

      {PERCENTS_OFF.map((percentOff, idx) => {
        const calculatedDiscountedPrice = calculateDiscountedPrice(originalPrice, percentOff);
        const isSelected = currentPrice.amountCents === calculatedDiscountedPrice.amountCents;

        return (
          <FilterChip
            key={idx}
            selected={isSelected}
            onClick={() => {
              trackEvent({
                eventName: MParticleEventName.PercentOffFilterChipClicked,
                componentName: COMPONENT_NAME,
                listingId,
                discountPercent: percentOff,
              });

              updatePrice(calculatedDiscountedPrice);
            }}
          >
            {I18n.t('discovery.listingsManagement.quickPriceEdit.modal.percentOffFilterChips.percentOff', { percentOff })}
          </FilterChip>
        );
      })}
    </div>
  );
}
